<template>
  <div class="fl-stepper-ctr h_steppers">
    <el-row justify="space-between">
      <el-col :span="8">
        <div
          class="fl-stepper active-step h_stepper_active h_stepper_select_site"
          v-bind:style="{
            color: activeStepperColor,
            borderColor: activeBorderColor
          }"
        >1. SELECT A SITE</div>
      </el-col>
      <el-col :span="8">
        <div
          class="fl-stepper h_stepper_inactive h_stepper_verify_credentials"
          v-bind:style="{
            color: inactiveStepperColor,
            borderColor: inactiveBorderColor
          }"
        >2. VERIFY CREDENTIALS</div>
      </el-col>
      <el-col :span="8">
        <div
          class="fl-stepper h_stepper_inactive h_stepper_view_accounts"
          v-bind:style="{
            color: inactiveStepperColor,
            borderColor: inactiveBorderColor
          }"
        >3. VIEW ACCOUNTS</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { custToolHelper } from '../../mixins/custToolHelper'
export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  created() {},
  mixins: [custToolHelper],
  computed: {
    activeStepperColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'stepper_active_text_color',
        'steppers'
      )
    },
    inactiveStepperColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'stepper_inactive_text_color',
        'steppers'
      )
    },
    activeBorderColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'stepper_active_border_color',
        'steppers'
      )
    },
    inactiveBorderColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'stepper_inactive_border_color',
        'steppers'
      )
    }
  },
  methods: {}
}
</script>

<style>
.fl-stepper-ctr {
  position: relative;
  height: 54px;
}
.fl-stepper {
  text-align: center;
  border-bottom: 2px solid #eeefee;
  line-height: 54px;
}
.active-step {
  border-color: #0c76be;
}
</style>
